import { Link } from "react-router-dom";

const DeveloperSVG = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
    />
  </svg>
);

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-white bg-darkBlue">
      <div className="container mx-auto px-4 py-12">
        <div className="flex flex-col sm:flex-row justify-between pb-8 border-b border-gray-700">
          <div className="mb-6 sm:mb-0 sm:w-1/3">
            <Link
              to="/"
              className="text-3xl font-extrabold tracking-wider flex items-center mb-4"
            >
              <DeveloperSVG className="w-8 h-8 mr-2 text-crimson" />
              <span className="text-crimson">Rifal</span>Ali
            </Link>
            <p className="text-gray-400 max-w-xs">
              Let's build something impactful together. Feel free to reach out
              for project inquiries or collaboration.
            </p>
          </div>

          <div className="w-full sm:w-1/3 mb-6 sm:mb-0">
            <h2 className="text-xl font-bold mb-4 text-crimson">Menu</h2>
            <ul className="space-y-2 text-gray-300">
              <li>
                <Link
                  to="/"
                  className="hover:text-white transition duration-150"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/work"
                  className="hover:text-white transition duration-150"
                >
                  Work
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="hover:text-white transition duration-150"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-white transition duration-150"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="w-full sm:w-1/3">
            <h2 className="text-xl font-bold mb-4 text-crimson">Social</h2>
            <ul className="space-y-2 text-gray-300">
              <li>
                <a
                  href="http://github.com/RifalAli/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition duration-150"
                >
                  Github
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/rifalalifh/"
                  className="hover:text-white transition duration-150"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/rifal.ali.526/"
                  className="hover:text-white transition duration-150"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="http://linkedin.com/in/rifalali/"
                  className="hover:text-white transition duration-150"
                >
                  Linkedln
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright & Bottom Bar */}
        <div className="pt-6 text-center text-sm text-gray-500">
          &copy; {currentYear} Mohammad Rifal Ali Fahri. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
